import clsx from "clsx";
import MainScaffold from "ui/common/components/layout/MainScaffold/MainScaffold";
import useTranslate from "ui/locale/hooks/useTranslate";
import MainStatsCharts from "ui/stats/containers/MainStatsCharts/MainStatsCharts";
import PointList from "ui/point/containers/PointList/PointList";

export interface MainStatsPageProps {
    className?: string;
    style?: React.CSSProperties;
}

function MainStatsPage({ className, ...rest }: MainStatsPageProps) {
    const translate = useTranslate();
    return (
        <MainScaffold className={clsx("main-stats-page", className)} title={translate("fullName")} {...rest}>
            {{
                content: <PointList />,
                footer: <MainStatsCharts />,
            }}
        </MainScaffold>
    );
}

export default MainStatsPage;
